import type { DeliverySettingsAPIDeliveryOptionCode } from 'src/services/delivery-settings/types/DeliverySettingsAPIDeliveryOptionCode';

export const getDeliveryOptionText = (
  optionCode: DeliverySettingsAPIDeliveryOptionCode,
): string => {
  switch (optionCode) {
    case 'EXPRESS_24':
      return 'Express Delivery';
    case 'SATURDAY':
      return 'Saturday Guaranteed';
    case 'FREE':
    case 'STANDARD':
    default:
      return 'Standard Delivery';
  }
};
